<template>
    <section class="c-email-subscription">
        <y-loading
            v-if="!newsletterData"
            :active="true"
            size="60"
            height="100%"
            position="relative"
        />
        <div
            v-else
            class="c-email-subscription--loaded"
        >
            <p
                v-if="newsletterData.title"
                class="c-email-subscription__title"
            >
                {{ newsletterData.title }}
            </p>
            <p
                v-if="newsletterData.title2"
                class="c-email-subscription__description"
            >
                {{ newsletterData.title2 }}
            </p>
            <div class="c-email-subscription__form">
                <div class="subscription-form">
                    <y-input
                        v-model="model.email"
                        :placeholder="$t('fields.email')"
                        color="white"
                        size="large"
                        no-label
                        class="subscription-form__email"
                    />
                    <y-button
                        :content="newsletterData.custom['button-title'] || $t('general.footer.newsletter_button')"
                        color="primary"
                        loading-on="saving-comment"
                        size="medium"
                        flat
                        :no-padding="false"
                        @click.prevent="beforeSubmit"
                    />

                    <y-recaptcha
                        v-if="$settings('recaptcha')"
                        ref="recaptcha"
                        :site-key="$settings('recaptcha.site_key')"
                        :size="$settings('recaptcha.size')"
                        @verify="afterVerify"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script >

    import {
        YInput,
        YRecaptcha,
    } from '@groot-components/all';

    export default {
        name      : 'BlogEmailSubscription',
        components: {
            YRecaptcha,
            YInput,
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                newsletterData: null,
                model         : {
                    email: '',
                },
            };
        },

        /**
         *
         * @inheritDoc
         */
        created() {
            this.fetch();
        },
        /**
         *
         * @inheritDoc
         */
        methods: {
            /**
             * Verify recaptcha
             * Check recaptcha is active
             */
            beforeSubmit() {
                this.$wait.start('saving-comment');
                if (this.$settings('recaptcha')?.active_for_guests === '1') {
                    this.$refs.recaptcha.verify();
                } else {
                    this.save();
                }
            },

            /**
             * Set token and start Sending Comment
             *
             * @param {string} token
             */
            afterVerify(token) {
                this.model['g-recaptcha-response'] = token;
                this.save();
            },

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * fetch hero data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-newsletter');

                const newsletterData = this.$services.Content.postSingle({
                    type     : 'pages',
                    slug     : 'newsletter2',
                    including: ['id', 'title', 'title2', 'custom'],
                    locale   : this.$i18n.locale,
                }).then((response) => {
                    this.newsletterData = response.data.results;
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([newsletterData])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.newsletterData = responses[0].data.results;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-newsletter');
                    });
            },

            /**
             * Do send comment
             *
             * @returns {object}
             */
            save() {
                return this.$services.Commenting.commentSave({
                    ...this.model,
                    id  : this.get(this.newsletterData, 'id'),
                    type: 'pages',
                    slug: 'newsletter2',
                }).then(() => {
                    this.model = { email: '' };
                    this.$toast.success(this.$t('general.footer.success_msg'));
                }).catch((error) => {
                    this.handleError(error, this.$t('general.footer.error_msg'));
                }).finally(() => {
                    this.$wait.end('saving-comment');
                    this.$refs.recaptcha.reset();
                });
            },
        },
    };

</script>

<style lang="scss" src="./email-subscription.scss"/>
